import {performHttpRequest} from "../http";

export async function getScales(template = undefined) {
    let url = window.kaartViewerUrl + '/admin/rest/printapi/bookmark/' + window.websiteName + '/scales'

    if(template) {
        url += '/' + template
    }

    return performHttpRequest(
        url,
        'GET'
    )
}

export async function print(data) {
    // const url = 'https://beta.kaartviewer.nl/admin/rest/printapi/bookmark/118'
    const url = window.kaartViewerUrl + '/admin/rest/printapi/bookmark/' + window.websiteName

    return performHttpRequest(
        url +  '/print',
        'POST',
        data
    )
}

export async function poll(ref) {
    // const url = 'https://beta.kaartviewer.nl/admin/rest/printapi/bookmark/118'
    const url = window.kaartViewerUrl + '/admin/rest/printapi/bookmark/' + window.websiteName

    return performHttpRequest(
        url + '/poll/' + ref,
        'GET'
    )
}

export async function cancelPrint(ref) {
    // const url = 'https://beta.kaartviewer.nl/admin/rest/printapi/bookmark/118'
    const url = window.kaartViewerUrl + '/admin/rest/printapi/bookmark/' + window.websiteName

    return performHttpRequest(
        url + '/cancel/' + ref,
        'GET'
    )
}
